import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Check, SquarePlus } from 'lucide-react';
import { Typography, Tooltip } from '@material-tailwind/react';
import { Controller } from 'react-hook-form';
import { Dialog } from '@mui/material';
import { AddModalCatLn } from '../Modal/AddModalCatLn';

const checkedIcon = <Check fontSize="small" />;

export default function SelectTagMui({ marcas, register, control, getMarcas = false }) {
  const [open, setOpen] = React.useState(false);
  const handleOpenMarca = () => {
    setOpen(!open);
  };

  return (
    <div className="w-[90%] md:w-[50%] px-5 md:px-0 ">
      <Typography
        variant="h6"
        color="black"
        className="mb-1 text-left font-medium dark:!text-darkText flex gap-x-2"
      >
        Marca de Compra
        <Tooltip content="Nova marca">
          <SquarePlus
            className="dark:opacity-100 dark:text-darkText cursor-pointer"
            onClick={handleOpenMarca}
          />
        </Tooltip>
      </Typography>
      <Controller
        name="marcaDeCompra"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <Autocomplete
            {...field}
            multiple
            id="checkboxes-tags-demo"
            options={marcas}
            disableCloseOnSelect
            getOptionLabel={(option) => option.nome}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  <Typography className="uppercase font-normal">{option.nome}</Typography>
                </li>
              );
            }}
            sx={{
              width: '100%',
              bgcolor: '#fff',
              borderColor: 'transparent',
              textTransform: 'uppercase',
              borderRadius: '7px',
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                placeholder="MARCAS PREFERIDA"
                sx={{ color: 'red' }}
              />
            )}
            onChange={(_, value) => field.onChange(value)} // Atualiza o estado do RHF
          />
        )}
      />
      <>
        <Dialog open={open} onClose={handleOpenMarca}>
          <AddModalCatLn
            modal={open}
            handleModal={handleOpenMarca}
            url={'marca'}
            title={`Nova Marca de Compra`}
            news={getMarcas}
          />
        </Dialog>
      </>
    </div>
  );
}
